import React, { useState, useEffect } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import Garantie24 from '../assets/24Garantie.jpg'

function CustomerRepresenterAddForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [customerRepresenterCode, setCustomerRepresenterCode] = useState('');
    const [isRepresent, setIsRepresent] = useState(false);

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '50%'
    };

    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    useEffect(() => {
        setOpen(true);
        axios.get('/api/v1/Profile/HasAddedCustomerRepresenterCode', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then((res) => {
            setIsRepresent(res.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('/api/v1/Profile/AddCustomerRepresenter', null,
            {
                params: {
                    CustomerId: getAuthenticationToken().userID,
                    CustomerRepresenterCode: customerRepresenterCode
                }
            }
        ).then(response => {
            setMessageNotify({
                severity: "success",
                message: "کد معرف با موفقیت ثبت شد",
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ثبت معرف، کد معرف صحیح نمی باشد",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }
    const resultView = (isRepresent ?
        <div style={{ margin: '90px 0px 20px 0px', textAlign: 'center', fontSize: 'large' }}>
            شما قبلا یک بار کد معرف ثبت کرده اید و امکان ثبت مجدد آن وجود ندارد.
        </div> :
        <>
            <div style={{ margin: '90px 0px 20px 0px', textAlign: 'center', fontSize: 'large' }}>
                جهت ثبت معرف کد دریافتی از ایشان را وارد نمائید
            </div>
            <form onSubmit={handleSubmit}>
                <Grid>
                    <div style={paperStyle}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="postalCode"
                            name="postalCode"
                            label="کد معرف"
                            fullWidth
                            variant="standard"
                            value={customerRepresenterCode}
                            onChange={e => setCustomerRepresenterCode(e.target.value)} />
                    </div>
                </Grid>
                <div style={footerButtonContainerStyle}>
                    <div style={footerButtonStyle}>
                        <Button
                            id="submit"
                            type='submit'
                            name="submit"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>ثبت</Button>
                    </div>
                    <div style={footerButtonStyle}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>انصراف</Button>
                    </div>
                </div>
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <img src={Garantie24} style={{ width: '300px' }} />
                </div>
                <div style={{ textAlign: 'center' }}>
                    <span style={{ fontSize: 'xx-large' }}>گارانتی نا محدود</span>
                </div>
                <div style={{ textAlign: 'center', padding: '0px 20px' }}>
                    <span style={{ fontSize: 'large' }}>ثــبــت 2% از مبـــــلغ خــریــداری شـــده بــرای</span>
                </div>
                <div style={{ textAlign: 'center', padding: '0px 20px' }}>
                    <span style={{ fontSize: 'large' }}>خریدار و فروشنده نهایی محصولات NEC</span>
                </div>
            </form>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>)

    return (
        resultView
    );
}

export default withRouter(CustomerRepresenterAddForm);